// extracted by mini-css-extract-plugin
export var scrollArea = "_p8-0";